<template lang="html">
  <div ref="wrapper" class="scroll">
    <slot></slot>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
// import {mapMutations, mapGetters} from 'vuex'
export default {
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: null
    },
    listenScroll: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    setTimeout(() => {
      this._initScroll()
      window.addEventListener('resize', () => {
        this.refresh()
      })
    }, 30)
  },
  // computed: {
  //   ...mapGetters([
  //     'navShow'
  //   ])
  // },
  methods: {
    // ...mapMutations({
    //   setNavShow: 'SET_NAVSHOW'
    // }),
    _initScroll () {
      if (!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click
      })
      if (this.listenScroll) {
        let me = this
        this.scroll.on('scroll', (pos) => {
          me.$emit('scroll', pos)
          // if (!this.navShow) {
          //   return false
          // }
          // if (pos.y < 0) {
          //   this.setNavShow(false)
          // }
        })
      }
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    refresh () {
      this.scroll && this.scroll.refresh()
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    }
  },
  watch: {
    data () {
      setTimeout(() => {
        this.refresh()
      }, 30)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.scroll
  position: fixed;
  left: 0;
  top: 95px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  transition: 0.3s
</style>



// WEBPACK FOOTER //
// src/base/scroll/scroll.vue